import TableRow from "@mui/material/TableRow";
export const Headers = ({
                            children,
                        }) => {
    return <TableRow>{children}</TableRow>;
};

Headers.dslType = "headers";
export default Headers;